import { getBuyerId } from 'dibs-cookie-jar';
import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';

import { canShowTradePromoModal, isAtViewLimit } from './tradePromoHelpers';
import { TRADE_PROMO_CODES } from './constants';

const query = graphql`
    query tradePromoRule_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirm {
                    rewards {
                        currentPromoSegment(userId: $userId) {
                            promotion {
                                code
                            }
                        }
                    }
                }
            }
        }
    }
`;

function queryTradePromo(relayEnvironment) {
    const userId = getBuyerId(document.cookie);
    return fetchQuery(relayEnvironment, query, { userId }).then(data => {
        const tradePromo = get(
            data,
            'viewer.user.tradeFirm.rewards.currentPromoSegment.promotion.code'
        );
        const shouldOpenModal =
            TRADE_PROMO_CODES.includes(tradePromo) && !isAtViewLimit(tradePromo);

        return shouldOpenModal;
    });
}

export function tradePromoRule({ relayEnvironment }) {
    if (canShowTradePromoModal()) {
        return queryTradePromo(relayEnvironment);
    }

    return Promise.resolve(false);
}
